module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAXCAMAAABd273TAAAATlBMVEUAAAD0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVy/QCgWAAAAGXRSTlMA8KAfkcHhvPnzQLDls51pQScH2sxvTkovQ+9T7gAAAIdJREFUKM+lkscOwzAMQ6lantnp1P//aFUf6yBCknfwgSYEDcJFUhjK4umf6BClMgHw0hJBUrkBkA3oqGEqc5D0Lq8k97k8W4MDvIpQuQPcrmHYNHTMWWTkUb+YhxNNUujr+1P7kFvDAjwkr1iTeOBjTmFWONxDg7kHe5P2FPY1rwfGzKSZ6i98virMAy8ASQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bottom_tel2.png
// module id = +9r9
// module chunks = 1